import React from 'react';

import styled from 'styled-components';

import imgLoading from '../img/Spinner-1s-200px.gif';

const Loading = ({ isVisible = true, isFullScren = true }) => {
	if (isVisible) {
		return (
			<Container $isFullScren={isFullScren}>
				<img src={imgLoading} alt="loading" />
			</Container>
		);
	}

	return null;
};

export default Loading;

const Container = styled.div`
	align-content: center;
	background-color: rgba(0, 0, 0, 0.8);
	display: flex;
	height: ${(p) => (p.$isFullScren ? '100vh' : '100%')};
	justify-content: center;
	position: absolute;
	width: 100%;
	z-index: 3;

	& img {
		height: 120px;
		margin: auto;
		width: 120px;
	}
`;
